import type { PrivacySettings, Theming, UserGrant } from './types'

export async function getTheming(accessToken: string, authority: string, orgid?: string): Promise<Theming> {
  const headers: HeadersInit = {
    Accept: 'application/json',
    Authorization: `Bearer ${accessToken}`,
  }

  if (orgid) {
    headers['x-zitadel-orgid'] = orgid
  }

  const res = await fetch(
    `${authority}/auth/v1/policies/label`,
    {
      method: 'GET',
      headers,
    },
  )
  return (await res.json())?.policy
}

export async function getPrivacySettings(accessToken: string, authority: string): Promise<PrivacySettings> {
  const res = await fetch(
    `${authority}/auth/v1/policies/privacy`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  )
  return (await res.json())?.policy
}

export async function getUserGrants(
  accessToken: string,
  authority: string,
): Promise<UserGrant[]> {
  const res = await fetch(`${authority}/auth/v1/usergrants/me/_search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      query: {
        offset: '0',
        limit: 100,
        asc: true,
      },
    }),
  })
  return (await res.json()).result
}

export async function getUserPermissions(accessToken: string, authority: string): Promise<any> {
  const res = await fetch(`${authority}/auth/v1/permissions/zitadel/me/_search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },

  })

  return (await res.json()).result ?? []
}

export async function getUserInfo(
  accessToken: string,
  authority: string,
  user: string,
): Promise<{ user: UserInfo }> {
  const res = await fetch(`${authority}/management/v1/users/${user}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return await res.json()
}

export interface UserInfo {
  id: string
  details: Details
  state: string
  userName: string
  loginNames: string[]
  preferredLoginName: string
  human: Human
}

interface Details {
  sequence: string
  creationDate: Date
  changeDate: Date
  resourceOwner: string
}

interface Human {
  profile: Profile
  email: Email
  phone: Phone
  passwordChanged: Date
}

interface Email {
  email: string
  isEmailVerified: boolean
}

interface Phone {
}

interface Profile {
  firstName: string
  lastName: string
  displayName: string
  preferredLanguage: string
  gender: string
}
